import { render, staticRenderFns } from "./jak-inwestowac-w-sektor-zbrojeniowy.md?vue&type=template&id=b9645fb4&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports